import React from 'react'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup
} from '../modal-form/modal-form'

const constraints = {
  'width': '706px',
  'minWidth': '706px'
}

export default ({
  fields: {
    technicianId
  },
  technicians,

  handleSubmit,
  handleClose,
  modalTitle,
  submitButtonText
}) => (
  <BaseModal
    onClose={handleClose}
    title={modalTitle}
    constraints={constraints}
    contentClassName='work-orders-create-container'
  >
    <ModalForm onSubmit={handleSubmit} customClassName='work-orders-create-form'>
      <ModalFormRow>
          <CheckboxGroup title='select tech'>
            {
              technicians.map((technician) => (
                <label key={technician.id}>
                  <input
                    type='radio'
                    {...technicianId}
                    value={technician.id}
                    checked={
                      technicianId.value &&
                        technicianId.value.toString() === technician.id.toString()
                    }
                  />
                  <span className='indicator' />
                  {technician.name}
                </label>
              ))
            }
            <label key='none'>
              <input
                type='radio'
                {...technicianId}
                value={''}
                checked={
                  !technicianId.value
                }
              />
              <span className='indicator' />
              None
            </label>
          </CheckboxGroup>
      </ModalFormRow>

      <ModalFormRow>
        <ModalFormBlock submitButton>
          <button type='submit'>
            {submitButtonText || 'Assign'}
          </button>
        </ModalFormBlock>
      </ModalFormRow>
    </ModalForm>
  </BaseModal>
)



// WEBPACK FOOTER //
// ./src/components/servicings/assign-servicing.js